<template>
  <div class="container register">
    <h2 class="fw-bold text-dark text-center mb-4">Edit Ship Call</h2>
    <div class="glass-panel p-5 mt-5">
      <div class="text-center mb-5">
        <img class="logo" alt="logo" src="@lib/frontend/assets/new.png" style="max-height: 80px;">
      </div>
      <b-form @submit.prevent="saveTemplate">
        <div class="row g-4">
          <!-- Fields flow naturally -->
          <div class="col-md-4">
            <b-form-group label="Date" label-class="text-muted small fw-bold mb-2">
              <b-form-datepicker v-model="template.attributes.date"></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Drop-off Location" label-class="text-muted small fw-bold mb-2">
              <b-form-select v-model="template.attributes.drop_off_location" :options="locationOptions" class="form-control"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Pick-up Location" label-class="text-muted small fw-bold mb-2">
              <b-form-select v-model="template.attributes.pick_up_location" :options="locationOptions" class="form-control"></b-form-select>
            </b-form-group>
          </div>

          <div class="col-md-4">
            <b-form-group label="Closest Public Train Station" label-class="text-muted small fw-bold mb-2">
              <b-form-select v-model="template.attributes.underground_station" :options="locationOptions" class="form-control"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Emergency Contact" label-class="text-muted small fw-bold mb-2">
              <b-form-input type="text" v-model="template.attributes.emergency_tc" class="form-control"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Meeting Time" label-class="text-muted small fw-bold mb-2">
              <b-form-input type="text" v-model="template.attributes.meeting_time" class="form-control" placeholder="HH:mm"></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-4" v-if="template.type !== 'Train'">
            <b-form-group label="Bus Return Departure Time" label-class="text-muted small fw-bold mb-2">
              <b-form-input type="text" v-model="template.attributes.busDepartureTime" class="form-control" placeholder="HH:mm"></b-form-input>
            </b-form-group>
          </div>
          
          <div class="col-md-4" v-if="template.type !== 'Bus'">
            <b-form-group label="Departure Train Station" label-class="text-muted small fw-bold mb-2">
              <b-form-select v-model="template.attributes.train_station" :options="locationOptions" class="form-control"></b-form-select>
            </b-form-group>
          </div>

          <div class="col-md-4" v-if="template.type !== 'Bus'">
            <b-form-group label="Train Departure Time" label-class="text-muted small fw-bold mb-2">
              <b-form-input type="text" v-model="template.attributes.train_departuretime" class="form-control" placeholder="HH:mm"></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-4">
            <b-form-group label="Euro Exchange" label-class="text-muted small fw-bold mb-2">
              <b-form-select v-model="template.attributes.euro_exchange" :options="locationOptions" class="form-control"></b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="mt-5 text-center d-flex justify-content-center gap-3">
          <b-button type="submit" variant="success" class="btn btn-primary-gradient px-5 py-2 rounded-pill shadow-sm fw-bold">
            <i class="fa fa-save me-2"></i> Save Changes
          </b-button>
          <router-link :to="{ name: 'templates' }" class="btn btn-light px-5 py-2 rounded-pill shadow-sm fw-bold text-dark text-decoration-none">Cancel</router-link>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      template: {
        attributes: {
          busDepartureTime: '',
          meeting_time: '',
          train_departuretime: '',
          date: '',
          drop_off_location: '',
          pick_up_location: '',
          underground_station: '',
          train_station: '',
          emergency_tc: '',
          euro_exchange: ''
        },
        type: ''
      },
      locationOptions: []
    };
  },
  created() {
    this.fetchTemplate();
    this.fetchLocations();
  },
  methods: {
  formatTime(time) {
    if (!time) return '';
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`;
  },
  async fetchTemplate() {
    const templateId = this.$route.params.id;
    const response = await this.$xhr.get(`/api/sk-items/${templateId}?populate=*`);
    const data = response.data.data;

    const { attributes } = data;

    this.template.attributes = {
      busDepartureTime: this.formatTime(attributes.busDepartureTime),
      meeting_time: this.formatTime(attributes.meeting_time),
      train_departuretime: this.formatTime(attributes.train_departuretime),
      date: attributes.date,
      emergency_tc: attributes.emergency_tc,
      drop_off_location: attributes.drop_off_location?.data?.id || '',
      pick_up_location: attributes.pick_up_location?.data?.id || '',
      underground_station: attributes.underground_station?.data?.id || '',
      train_station: attributes.train_station?.data?.id || '',
      euro_exchange: attributes.euro_exchange?.data?.id || ''
    };

    this.template.type = attributes.sk_templates?.data?.attributes?.type || '';
  },
  async fetchLocations() {
    const response = await this.$xhr.get('/api/sk-locations');
    this.locationOptions = response.data.data.map(location => ({
      value: location.id,
      text: location.attributes.name
    }));
  },
  async saveTemplate() {
  // Validate that required fields are not empty
  if (!this.template.attributes.drop_off_location || 
      !this.template.attributes.pick_up_location ||
      !this.template.attributes.underground_station ||
      (this.template.type !== 'Train' && !this.template.attributes.busDepartureTime) ||
      (this.template.type !== 'Bus' && (!this.template.attributes.train_station || !this.template.attributes.train_departuretime))) {
    console.error('Please fill out all required fields.');
    return;
  }
  const { id } = this.$route.params;

  const payloadAttributes = { ...this.template.attributes };
  
  // Format times back to HH:mm:ss.000 for strict Strapi backend validation
  const ensureSeconds = (timeStr) => timeStr && timeStr.length === 5 ? `${timeStr}:00.000` : timeStr;
  payloadAttributes.meeting_time = ensureSeconds(payloadAttributes.meeting_time);
  payloadAttributes.busDepartureTime = ensureSeconds(payloadAttributes.busDepartureTime);
  payloadAttributes.train_departuretime = ensureSeconds(payloadAttributes.train_departuretime);

  // If the type is 'Bus', remove train_station and train_departuretime from the payload
  if (this.template.type === 'Bus') {
    delete payloadAttributes.train_station;
    delete payloadAttributes.train_departuretime;
  }

  try {
    await this.$xhr.put(`/api/sk-items/${id}`, { data: payloadAttributes });
    this.$router.push({ name: 'templates' });
  } catch (error) {
    console.error('Error saving template:', error);
  }
}

}

};
</script>

